import { cloneDeep } from 'lodash-es';

/**
 * Removes undefined, null, and empty array values from filter variables
 * This ensures clean URLs without unnecessary query parameters
 */
export function cleanFilterVariables<T extends Record<string, any>>(variables: T): T {
  const merged = cloneDeep(variables);
  cleanObject(merged);
  if ('filter' in merged && merged.filter && typeof merged.filter === 'object') {
    cleanObject(merged.filter as Record<string, any>);
  }
  return merged;
}

/**
 * Removes undefined, null, and empty array values from an object
 * Mutates the object in place
 */
function cleanObject(data: Record<string, any>): void {
  Object.keys(data).forEach((key) => {
    const val = data[key];
    if (val === undefined || val === null || (Array.isArray(val) && val.length === 0)) {
      delete data[key];
    }
  });
}
